import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class ConfirmDialogComponent implements OnInit {

    constructor(public bsModalRef: BsModalRef) { }

    public onClose: Subject<boolean>;
    ngOnInit(): void {
        this.onClose = new Subject();
    }

    confirm() {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }
}
